import { render, staticRenderFns } from "./AnimatedCounter.vue?vue&type=template&id=65e35227&scoped=true"
import script from "./AnimatedCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedCounter.vue?vue&type=script&lang=js"
import style0 from "./AnimatedCounter.vue?vue&type=style&index=0&id=65e35227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e35227",
  null
  
)

export default component.exports